import React, { useContext, useRef } from "react"
import { Dimensions, View } from "react-native"
import { DimensionsContext, IS_WEB } from "../../utils/mobileUtils"
import { theme } from "../../theme/theme"
import { PinchableSvgBox } from "./PinchableSvgBox"
import { IconButton } from "react-native-paper"
import IconButtonM from "@common/components/button/IconButtonM"

function SvgViewer(props) {
    const {
        svgContent,
        close,
        clearMode = false,
        width = null,
    } = props

    const pinchableBoxRef = useRef()
    const dimensions = useContext(DimensionsContext)

    const itemWidth = width ?? Dimensions?.get("window")?.width
    const buttonsColor = clearMode ? theme.colors.primary : theme.colors.white

    return (
        <View style={{ flex: 1 }}>
            <View
                style={{
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    paddingBottom: 5,
                }}
            >
                {!!close && (
                    <IconButton
                        icon={"times"}
                        iconColor={buttonsColor}
                        containerColor={theme.colors.transparent}
                        size={32}
                        onPress={close}
                    />
                )}
            </View>

            <View style={{ flex: 1 }}>
                <PinchableSvgBox
                    svgContent={svgContent}
                    imageStyle={{
                        width: itemWidth,
                        height: dimensions?.height,
                    }}
                    ref={pinchableBoxRef}
                />
            </View>

            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {IS_WEB && (
                    <IconButtonM
                        size={30}
                        icon={"minus-circle"}
                        iconColor={buttonsColor}
                        onPress={() => {
                            if (pinchableBoxRef.current) {
                                pinchableBoxRef.current.zoomOut()
                            }
                        }}
                    />
                )}

                <IconButtonM
                    size={30}
                    icon={"redo"}
                    iconColor={buttonsColor}
                    onPress={() => {
                        if (pinchableBoxRef.current) {
                            pinchableBoxRef.current.rotate()
                        }
                    }}
                />

                {IS_WEB && (
                    <IconButtonM
                        size={30}
                        icon={"plus-circle"}
                        iconColor={buttonsColor}
                        onPress={() => {
                            if (pinchableBoxRef.current) {
                                pinchableBoxRef.current.zoomIn()
                            }
                        }}
                    />
                )}
            </View>
        </View>
    )
}

export default SvgViewer
